import { createContext } from 'use-context-selector';
import type { GraphRendererApi } from './types';

export type GraphRendererContextValue = {
  getApi: () => GraphRendererApi | null;
  ready: boolean;
};

export const GraphRendererContext = createContext<GraphRendererContextValue>({
  getApi: () => null,
  ready: false,
});
